import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, InputSignal, Signal, ViewEncapsulation, input, viewChild } from '@angular/core';

/**
 * Broadcast messages created in HelpDesk using TinyMCE rich text editor (with reduced styling options, e.g. images or uploads
 * are not supported) which output HTML formatted messages without <html></html>, <head></head> or <body></body> elements.
 * When shown in WebBroker same TinyMCE CSS styles are applied to the message body to make sure they look the same as in HelpDesk.
 *
 * See: https://stackoverflow.com/questions/36265026/angular-2-innerhtml-styling
 */
@Component({
  selector: 'td-wb-messages-body',
  templateUrl: 'messages-body.component.html',
  styleUrls: ['messages-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class MessagesBodyComponent implements AfterViewInit {
  readonly content: InputSignal<string | undefined> = input<string | undefined>(undefined);
  readonly messageContainer: Signal<ElementRef | undefined> = viewChild<ElementRef>('messageContainer');

  ngAfterViewInit(): void {
    const container = this.messageContainer();
    if (container?.nativeElement) {
      container.nativeElement.innerHTML = this.content() ?? '';
    }
  }
}
